class InitializeResult {
    static serialize(initializeResult) {
        const userId = initializeResult.userId;
        const playerCount = initializeResult.playerCount;
        const characterCount = initializeResult.characterCount;

        return {
            userId: userId,
            playerCount: playerCount,
            characterCount: characterCount,
        };
    }

    static deserialize(jsonObj) {
        const userId = jsonObj.userId;
        const playerCount = jsonObj.playerCount;
        const characterCount = jsonObj.characterCount;

        return (new InitializeResult(userId, playerCount, characterCount));
    }

    userId;
    playerCount;
    characterCount;

    constructor(userId, playerCount, characterCount) {
        this.userId = userId;
        this.playerCount = playerCount;
        this.characterCount = characterCount;
    }
}

export default InitializeResult;
